import { uniqueId } from "lodash"

import React, { useEffect, useState } from "react"
import classNames from "classnames"
import clsx from "clsx"
import { useContextMenu } from "react-contexify"
import { Check as ICON_CHECK, X as ICON_X } from "react-feather"
import { connect } from "react-redux"

import { mapDispatchProps, mapStateToProps } from "../../store/store"
import API from "@api/index"
import { useLanguage } from "@languages/index"
import dayjs from "../../plugins/dayjs"
import { delay } from "../../helpers/common"
import { debounce } from "../../helpers/debounce"
import Button from "@components/button"
import Label from "@components/label"
import Checkbox from "@components/checkbox"
import ModalType1 from "components/modalType1"
import RENTAL_POSTING_DUE from "@constants/rentalPostingDue"
import { isGlovvJp, isKyolook } from "constants/domains/domains"
import { CampaignStatus } from "pages/campaigns"
import { isEmpty } from "helpers/object"
import { InfluencerMessageModal } from "./InfluencerMessageModal"
import ModalRequestRecruitingCampaignApplicationBrand from "components/modalBrandRequestRecruitingCampaignApplication"

const STORAGE_KEYS = {
  BRAND_REQUEST_PHONE: 'brandRequestRecruitingCampaignApplication_phone',
  BRAND_REQUEST_SHOULD_SAVE: 'brandRequestRecruitingCampaignApplication_shouldSave',
};

export const TYPES = {
  CAMPAIGN: "CAMPAIGN",
  AMBASSADOR: "AMBASSADOR",
}

interface Props {
  className?: string
  onClick?: any

  type?: string
  isSelectable?: boolean
  selected?: boolean
  application?: any

  isShoes?: boolean
  isUnderwear?: boolean

  campaignData?: any

  showReject?: boolean

  style?: any
  showModal?: any
  closeModal?: any

  onLike?: any
  onProductUserLike?: any

  onReject?: any

  onAmbassadorApprove?: any
  onAmbassadorDecline?: any

  nextUser?: any
  previousUser?: any

  auth?: any
  brand?: any

  preferences?: any
  settings?: any
  instagram?: any
  setInstagram?: any
  appealReels?: any
  setAppealReels?: any

  isInfluencersPage?: any

  setListData? : (data: any[]) => void;
  productId?: string;
}

const returnInfluncerMessageButtonText = (campaignData: Props['campaignData'], application: Props['application'], languageTexts: ReturnType<typeof useLanguage>['component']['modelCard'])=>{
  const isModifyInfluncerMessage =campaignData?.status === CampaignStatus.RECRUIT_STARTED || campaignData?.status === CampaignStatus.SELECTION_STARTED;
  const isEmptyMessage = application?.influencerMessage === null ;
  if(isModifyInfluncerMessage){
    if(isEmptyMessage){
      return languageTexts?.influencer_message_button_text;
    } else {
      return languageTexts?.influencer_message_button_text_completed;
    }
  } else {
    if(isEmptyMessage){
      return languageTexts?.influencer_message_button_text_cannot_modify_empty_message;
    } else {
      return languageTexts?.influencer_message_button_text_cannot_modify_message;
    }
  }
}

const ModelCard = (props: Props) => {
  const canModifyInfluncerMessage =props.campaignData?.status === CampaignStatus.RECRUIT_STARTED || props.campaignData?.status === CampaignStatus.SELECTION_STARTED;
  
  const language = useLanguage()
  const languageTexts = {
    ...language.common,
    ...language.database.rental_posting_due,
    ...language.component.modelCard,
    ...language.pages.campaigns,
  }

  const postingDueReasonType_text_map = {
    [RENTAL_POSTING_DUE.REASON_TYPE.DELIVERY_DELAYED]: languageTexts.reason_type_1,
    [RENTAL_POSTING_DUE.REASON_TYPE.GUIDELINE]: languageTexts.reason_type_2,
    [RENTAL_POSTING_DUE.REASON_TYPE.SICKNESS]: languageTexts.reason_type_3,
    [RENTAL_POSTING_DUE.REASON_TYPE.ETC]: languageTexts.reason_type_9,
  }

  let className = clsx([
    "model-card flex flex-col p-[10px] border box-border",
    `${props.className ? props.className : ""}`,
    `${props.selected ? "border-[3px] border-[#ED8E00] -m-[2px]" : "border-gray-200"}`,
  ])

  const MODEL_MENU_ID = `model-menu-${uniqueId()}`

  const { show, hideAll } = useContextMenu({
    id: MODEL_MENU_ID,
  })

  const [isCommentVisible, setIsCommentVisible] = useState(false)
  const [isHistoryVisible, setIsHistoryVisible] = useState(false)
  // ADDED: State for other applying modal
  const [isOtherApplyingVisible, setIsOtherApplyingVisible] = useState(false)
  const [isInstagramOpened, setIsInstagramOpened] = useState(
    props.type == TYPES.CAMPAIGN
      ? props.instagram?.openedInCampaignPage?.includes(props.application.id)
      : props.instagram?.openedInAmbassadorPageUserId?.includes(props.application.id)
  )
  const [isAppealReelsOpened, setIsAppealReelsOpened] = useState(
    props.type == TYPES.CAMPAIGN
      ? props.appealReels?.openedInCampaignPage?.includes(props.application.id)
      : props.appealReels?.openedInAmbassadorPageUserId?.includes(props.application.id)
  )
   

  // const [isInstagramDrawerActive, setIsInstagramDrawerActive] = useState(false)
  // MODIFIED: Added OTHER_APPLYING for "다른 캠페인에도 지원중"
  const MODAL_TYPE = {
    COMMENT: "COMMENT",
    HISTORY: "HISTORY",
    OTHER_APPLYING: "OTHER_APPLYING",
    CONTEXT: "CONTEXT"
  }

  // useEffect(() => {
  //   if (props.instagram?.user?.id == props.application?.user?.id) {
  //     setIsInstagramDrawerActive(true)
  //   }
  // }, [props.instagram])

  const handleBrandRequestRecruitingCampaignApplicationClick = async () => {
  const savedPhone = sessionStorage.getItem(STORAGE_KEYS.BRAND_REQUEST_PHONE);

  // Always show modal (with pre-filled phone if saved)
  const response = await new Promise((resolve) => {
    props.showModal({
      content: () => (
        <ModalRequestRecruitingCampaignApplicationBrand
          isVisible={true}
          letClose={(result) => {
            resolve(result);
            props.closeModal?.();
          }}
          brandToken={props.auth.token}
          brandName={props.brand?.name}
          brandId={props.brand?.id}
          username={props.application.user?.username}
          savedPhoneNumber={savedPhone || ''}
          userModelSuggestedAt={props.application.user?.userModel?.suggestedAt}
          userId={props.application.user?.id}
          mobile={props.application.user?.mobile}
          userModelInstaUserId={props.application.user?.userModel?.instaUserId}
          showModal={props.showModal}
          onSavePhoneNumber={(phone, shouldSave) => {
            if (shouldSave) {
              sessionStorage.setItem(STORAGE_KEYS.BRAND_REQUEST_PHONE, phone);
              sessionStorage.setItem(STORAGE_KEYS.BRAND_REQUEST_SHOULD_SAVE, 'true');
            } else {
              sessionStorage.removeItem(STORAGE_KEYS.BRAND_REQUEST_PHONE);
              sessionStorage.removeItem(STORAGE_KEYS.BRAND_REQUEST_SHOULD_SAVE);
            }
          }}
        />
      ),
    });
  });

  if (response) {
    props.showModal({
      hideCloseButton: true,
      title: languageTexts.brand_request_recruiting_campaign_application_modal_success_title,
      text: languageTexts.brand_request_recruiting_campaign_application_modal_success_text,
    });
  }
};


  const handleModals = (element, eventType, event) => {
    switch (element) {
      case MODAL_TYPE.COMMENT:
        if (eventType === "start") {
          setIsCommentVisible(true)
        } else {
          setIsCommentVisible(false)
        }
        break
      case MODAL_TYPE.HISTORY:
        if (eventType === "start") {
          setIsHistoryVisible(true)
        } else {
          setIsHistoryVisible(false)
        }
        break
      // ADDED: Case for "다른 캠페인에도 지원중" modal  
      case MODAL_TYPE.OTHER_APPLYING:
        if (eventType === "start") {
          setIsOtherApplyingVisible(true)
        } else {
          setIsOtherApplyingVisible(false)
        }
        break
      case MODAL_TYPE.CONTEXT:
        if (eventType === "start") {
          displayMenu(event)
        } else {
          hideAll()
        }
        break
      default:
        break
    }
  }

  const displayMenu = (e) => {
    show(e, {
      position: { x: e.clientX, y: e.clientY },
    })
  }

  const showModelRejectModal = (userId: number, isDelete: boolean = false) => {
    debounce(() => {
      props.showModal({
        title: isDelete ? languageTexts.modal_reject_title_1 : languageTexts.modal_reject_title_2,
        text: isDelete ? languageTexts.modal_reject_text_1 : languageTexts.modal_reject_text_2,
        cancel: () => {},
        confirm: () => {
          toggleReject(userId)
        },
      })
    }, 400)
  }

  const toggleReject = (userId: number) => {
    debounce(() => {
      API.Model.toggleReject({
        brandToken: props.auth.token,
        userId: userId,
      })
        .then((response: any) => {
          props.showModal({
            text: response.message,
          })

          props.onReject(props.application.user.id, response.data.result)
        })
        .catch((error) => {
          props.showModal({
            text: error.message,
          })
        })
    }, 400)
  }

  const handleOpenInstagramUrl = (params: { url: string; type: string; applicationId: number }) => {
    window.open(params.url, "_blank")

    setIsInstagramOpened(true)

    let prevArray
    switch (params.type) {
      case TYPES.CAMPAIGN:
        prevArray = props.instagram?.openedInCampaignPage ?? []
        props.setInstagram({
          openedInCampaignPage: [...prevArray, params.applicationId],
        })
        break
      case TYPES.AMBASSADOR:
        prevArray = props.instagram?.openedInAmbassadorPageUserId ?? []
        props.setInstagram({
          openedInAmbassadorPageUserId: [...prevArray, params.applicationId],
        })
        break
    }
  }

  const handleOpenAppealReels = (params: { url: string; type: string; applicationId: number }) => {
    window.open(params.url, "_blank")

    setIsAppealReelsOpened(true)

    let prevArray
    switch (params.type) {
      case TYPES.CAMPAIGN:
        prevArray = props.appealReels?.openedInCampaignPage ?? []
        props.setAppealReels({
          openedInCampaignPage: [...prevArray, params.applicationId],
        })
        break
      case TYPES.AMBASSADOR:
        prevArray = props.appealReels?.openedInAmbassadorPageUserId ?? []
        props.setAppealReels({
          openedInAmbassadorPageUserId: [...prevArray, params.applicationId],
        })
        break
    }
  }

  const isMobileDevice = () => {
    return /mobile|android|iphone|ipad|phone/i.test(navigator.userAgent)
  }

  // const openInstagramProfile = () => {
  //   const url = ``

  //   if (isMobileDevice()) {
  //     window.location.href = url
  //   } else {
  //     window.open(url, "_blank")
  //   }
  // }

  const isConfirmedModalShouldCheckReels = async () => {
    return new Promise((resolve, reject) => {
      const isBeautyBrand = props.brand?.isCategoryBeauty
      const isSuggestedUser = props.application.user?.suggestions?.length > 0
      const isReactivatedAtExpired =
        props.instagram?.modalShouldCheckReelsReactivatedAt == null ||
        dayjs().isAfter(props.instagram?.modalShouldCheckReelsReactivatedAt)
      if (isBeautyBrand && !isSuggestedUser && isReactivatedAtExpired) {
        props.showModal({
          hideCloseButton: true,
          content: () => {
            return (
              <ModalShouldCheckReels
                onConfirm={async () => {
                  props.closeModal()
                  await delay(200)
                  resolve(true)
                }}
              />
            )
          },
          cancel: () => {
            resolve(false)
          },
        })
        return
      } else {
        resolve(true)
      }
    })
  }

  const renderRentalPostingDues = (postingDues) => {
    if (postingDues == null || postingDues.length == 0) {
      return null
    }

    const lastPostingDue = postingDues[postingDues.length - 1]
    const isApproved = lastPostingDue.approvedAt != null && lastPostingDue.rejectedAt == null
    if (!isApproved) {
      return null
    }

    let reasonText = postingDueReasonType_text_map[lastPostingDue.reasonType]
    if (lastPostingDue.reasonType == RENTAL_POSTING_DUE.REASON_TYPE.ETC) {
      reasonText += ` (${lastPostingDue.reasonDescription})`
    }

    return (
      <div id={`rental-posting-due-${lastPostingDue.id}`} className="flex flex-col py-3 px-4 bg-[#1DCD00] rounded-sm">
        <div className="text-[12px] font-bold tracking-tighter text-white">
          {languageTexts.extended_posting_deadline}
        </div>
        <div className="text-[11px] tracking-tighter text-white">
          {dayjs(lastPostingDue.postingDueDt).format("YYYY-MM-DD")}
        </div>
        {reasonText != null && <div className="text-[11px] tracking-tighter text-white">{reasonText}</div>}
      </div>
    )
  }

  const renderPostingDtInfo = (
    rental_postingDt,
    campaignData_postingEndsAt,
    rental_inspectionSubmitDueDt,
    rental_inspectionSubmittedAt,
    rental_memo,
    rental_inspectionMemo,
    rentalPostingDues,
  ) => {
    let postingEndsDt = dayjs(campaignData_postingEndsAt)
    let inspectionSubmitDueDt = dayjs(rental_inspectionSubmitDueDt)
    let rentalInspectionSubmittedAt = dayjs(rental_inspectionSubmittedAt)
    if (
      rentalPostingDues != null &&
      rentalPostingDues.length > 0 &&
      rentalPostingDues[rentalPostingDues.length - 1].approvedAt != null &&
      rentalPostingDues[rentalPostingDues.length - 1].rejectedAt == null
    ) {
      postingEndsDt = dayjs(rentalPostingDues[rentalPostingDues.length - 1].postingDueDt)
    }

    return (
      <div>
        {renderRentalPostingDues(rentalPostingDues)}
        {!rental_postingDt && dayjs().isAfter(postingEndsDt) ? (
          <div className="flex flex-col py-3 px-4 bg-[#C21111] rounded-sm">
            <span className="text-[12px] font-bold tracking-tighter text-white">
              {languageTexts.exceeded_posting_deadline}
            </span>
            {rental_memo ? (
              <span className="text-[11px] tracking-tighter text-white">{`${props.application.rental.memo}`}</span>
            ) : null}
          </div>
        ) : null}
        {!rentalInspectionSubmittedAt && dayjs().isAfter(inspectionSubmitDueDt) ? (
          <div className="flex flex-col py-3 px-4 bg-[#C21111] rounded-sm">
            <span className="text-[12px] font-bold tracking-tighter text-white">
              {languageTexts.exceeded_inspection_deadline}
            </span>
            {rental_inspectionMemo ? (
              <span className="text-[11px] tracking-tighter text-white">
                {`${props.application.rental.inspectionMemo}`}
              </span>
            ) : null}
          </div>
        ) : null}
      </div>
    )
  }

  const renderProductContextTab = (application: any) => {
    if (props.type != TYPES.CAMPAIGN) return null

    return (
      <>
      {props?.isInfluencersPage ? 
        null : 
        <div
          className="w-[32px] h-[32px] flex justify-center items-center cursor-pointer animate__animated animate__fadeIn text-[#C8C8C8] p-[10px] md:p-[5px] z-[1]"
          style={{
            border: "1px solid rgba(0, 0, 0, 0.1)",
            boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
            borderRadius: "0px"
          }}
          onClick={() => {
            showModelRejectModal(application.userId, application.reject)
          }}
        >
          <img 
            src="/assets/icons/ic-close-C8C8C8-1.svg" 
            alt="close"
            className="w-1.5 h-1.5"
          />
        </div>
      }
      </>
    )
  }

  const renderInstagramButton = (params: { isInstagramOpened: boolean; onClick: any }) => {
  // Pre-calculate dynamic values
  const isInfluencersPage = props?.isInfluencersPage
  const isInstagramOpened = params.isInstagramOpened
  
  // Determine text color
  const textColor = isInfluencersPage
    ? "BLACK"
    : (isInstagramOpened ? "#C8C8C8" : "BLACK")
  
  // Determine button text
  const buttonText = isInfluencersPage
    ? "인스타그램 보기"
    : (isInstagramOpened ? languageTexts.instagram_opened : languageTexts.instagram)
  
  // Determine if icon should show
  const shouldShowIcon = isInfluencersPage || !isInstagramOpened
  
  // Create icon config
  const iconConfig = shouldShowIcon
    ? {
        position: "centerLeft" as const,
        icon: (
          <div className="self-center text-black ml-0.5 mr-0.5">
            <img
              className="w-4 h-4 cursor-pointer"
              src="/assets/icons/ic-instagram-sm.svg"
              alt="instagram"
            />
          </div>
        ),
      }
    : null

  return (
    <Button
      className="flex flex-row py-2 text-center justify-center gap-1 !rounded-none"
      buttonColor="WHITE"
      textColor={textColor}
      textClassName="text-[11px] tracking-tighter font-bold"
      text={buttonText}
      icon={iconConfig}
      onClick={params.onClick}
    />
  )
}

    const renderAppealReelsButton = (params: { isAppealReelsOpened: boolean; onClick: any }) => {
    // Pre-calculate all dynamic values
    const isInfluencersPage = props?.isInfluencersPage
    const isReelsOpened = params.isAppealReelsOpened
    
    // Determine text color
    const textColor = isInfluencersPage 
      ? "BLACK" 
      : (isReelsOpened ? "#C8C8C8" : "BLACK")
    
    // Determine button text
    const buttonText = isInfluencersPage
      ? "인스타그램 보기"
      : (isReelsOpened ? languageTexts.instagram_confirmed : languageTexts.view_appeal_reels)
    
    // Determine if icon should show
    const shouldShowIcon = isInfluencersPage || !isReelsOpened
    
    // Create icon config
    const iconConfig = shouldShowIcon
      ? {
          position: "centerLeft" as const,
          icon: (
            <div className="self-center text-black ml-0.5 mr-0.5">
              <img 
                className="w-4 h-4 cursor-pointer" 
                src="/assets/icons/ic-instagram-sm.svg"
                alt="instagram" 
              />
            </div>
          ),
        }
      : null

    return (
      <Button
        className="flex flex-row py-2 text-center justify-center gap-1 !rounded-none"
        buttonColor="WHITE"
        textColor={textColor}
        textClassName="text-[11px] tracking-tighter font-bold"
        text={buttonText}
        icon={iconConfig}
        onClick={params.onClick}
      />
    )
  }

  const ModalShouldCheckReels = (params: { onConfirm: any }) => {
    const [modalShouldCheckReelsReactivatedAt, setModalShouldCheckReelsReactivatedAt] = useState(
      props.instagram?.modalShouldCheckReelsReactivatedAt != null &&
        !dayjs().isAfter(props.instagram?.modalShouldCheckReelsReactivatedAt)
    )
    return (
      <div className="p-[30px] max-w-[360px] bg-white">
        <div className="flex flex-col gap-[5px]">
          <span className="font-bold">{languageTexts.should_check_reels_modal_title}</span>
          <span>{languageTexts.should_check_reels_modal_text}</span>
        </div>

        <div className="mt-[10px]">
          <Checkbox
            text={languageTexts.not_visible_today}
            checked={modalShouldCheckReelsReactivatedAt}
            onClick={(isChecked) => {
              props.setInstagram({
                ...props.instagram,
                modalShouldCheckReelsReactivatedAt: isChecked ? dayjs().add(1, "day") : null,
              })
              setModalShouldCheckReelsReactivatedAt(isChecked)
            }}
          />
        </div>

        <div className="mt-[20px] w-full">
          <Button
            text={languageTexts.confirm}
            buttonColor={"#000"}
            textColor={"#fff"}
            onClick={() => {
              params.onConfirm()
            }}
          />
        </div>
      </div>
    )
  }

    const handleInfluencerLikeBtnClick = async () => {
    if (props.application.likes && props.application.likes.length) {
      props.onLike?.()
      return
    }

    const modalHiddenStorageKey = 'brand_like_modal_hide_today'
    const hiddenUntil = localStorage.getItem(modalHiddenStorageKey)
    
    if (!hiddenUntil || dayjs().isAfter(dayjs(hiddenUntil))) {
      props.showModal({
        hideCloseButton: true,
        content: () => (
          <ModalType1
            closeModal={() => props.closeModal()}
            onConfirm={() => {
              props.closeModal()
              props.onLike?.()
            }}
            title={languageTexts?.brand_like_modal_menu_info_1}
            mainText={languageTexts?.brand_like_modal_menu_info_2}
            showDailyHideCheckbox={true}
            storageKey={modalHiddenStorageKey}  // ✅ Pass storage key
          />
        ),
      })
    } else {
      props.onLike?.()
    }
  }

  
  const influncerMessageButtonText = returnInfluncerMessageButtonText(props.campaignData, props.application, languageTexts);



  const handleInfluencerMessageBtnClick = (application: Props['application'])=> {
    props.showModal({
      content: () => (
        <InfluencerMessageModal 
          campaignData={props.campaignData} 
          handleOpenAppealReels={handleOpenAppealReels} 
          type={props.type as 'CAMPAIGN' | 'AMBASSADOR'} 
          isInfluencersPage={props.isInfluencersPage}
          canModifyInfluncerMessage={canModifyInfluncerMessage}
          users={[{...application.user, application : application}]}
          setListData={props?.setListData}
          productId={props.productId}
          />
      )
    })
  }


  

  return (
    <div
      className="flex flex-col select-none"
      onClick={props.onClick && props.onClick}
      data-user-id={`${props?.application?.user?.id}`}
    >
      <div className={className} style={props.style ? props.style : null}>
        <div className="relative flex flex-col">
          <div className="absolute flex items-center cursor-pointer -top-1 -right-1 md:-right-4 md:-top-4 bg-white z-[1]">
            {renderProductContextTab(props.application)}
          </div>
          <div
            className={classNames([
              "spacer w-full aspect-square",
              props.isSelectable ? "cursor-pointer" : "cursor-default",
            ])}
            onClick={props.onClick && props.onClick}
          >
            {props.application.user.profileBackgroundUrl ? (
              <img
                className="w-full h-full object-cover aspect-square"
                src={`${props.application.user.profileBackgroundUrl}`}
                draggable={false}
              />
            ) : (
              <div className="w-full h-full flex justify-center items-center bg-[black]/[.1]">
                <span className="text-sm w-36 text-center justify-center flex text-gray-400 tracking-tighter">
                  {languageTexts.non_bg_user}
                </span>
              </div>
            )}
          </div>
          <div
            className={classNames([
              "absolute right-0 bottom-[-24px]",
              props.isSelectable ? "cursor-pointer" : "cursor-default",
            ])}
            onClick={props.onClick && props.onClick}
          >
            <div className="border-white border-2 rounded-full overflow-hidden">
              <img className="w-[48px] h-[48px] rounded-full" src={`${props.application.user.profileImageUrl}`} />
            </div>
          </div>
          {!props?.isInfluencersPage && props.application.comment ? (
            <>
              <div
                className="absolute top-0 left-0 right-0 cursor-pointer"
                onMouseOver={(event) => !props.preferences.isMobile && handleModals(MODAL_TYPE.COMMENT, "start", event)}
                onMouseLeave={(event) => !props.preferences.isMobile && handleModals(MODAL_TYPE.COMMENT, "end", event)}
                onClick={() => {
                  if (props.preferences.isMobile) {
                    const command = isCommentVisible ? "end" : "start"
                    handleModals(MODAL_TYPE.COMMENT, command, null)
                  }
                }}
              >
                <div
                  className="flex flex-col justify-center py-2"
                  style={{
                    backgroundColor: `rgba(0,0,0, ${isCommentVisible ? 0.85 : 0.15})`,
                  }}
                >
                  <span className="flex flex-col text-center font-bold text-[11px] tracking-tighter text-white">
                    {/* {languageTexts._modelsComment(props.application.user.username)} */}
                    {languageTexts?.application_message_view}                    
                  </span>
                </div>
              </div>
              <div className={`${isCommentVisible ? "" : "hidden"}`}>
                <div
                  className={`flex flex-col fixed inset-0 justify-center items-center z-[10] translate-x-[-50%] translate-y-[-50%] left-[50%] top-[50%] ${
                    !props.preferences.isMobile ? "pointer-events-none" : ""
                  } animate__animated animate__fadeIn ${props.preferences.isMobile ? "w-[90vw]" : ""}`}
                >
                  <div
                    className={`flex flex-col bg-white rounded-[1.125rem] gap-5 p-5 md:p-10 ${
                      !props.preferences.isMobile ? "" : "pointer-events-auto"
                    }`}
                    style={{
                      boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.25)",
                    }}
                  >
                    <span className="flex flex-col text-start font-bold text-lg md:text-2xl tracking-tighter">
                      {languageTexts._modelsComment(props.application.user.username)}
                    </span>

                    <pre
                      className="w-full text-sm tracking-tighter text-black"
                      style={{
                        whiteSpace: "break-spaces",
                        wordBreak: "break-word",
                      }}
                    >
                      {`${props.application.comment}`}
                    </pre>
                    {props.preferences.isMobile ? (
                      <div>
                        <Button
                          className="w-full py-[8px] flex justify-center font-bold"
                          buttonColor={"#000"}
                          textColor={"WHITE"}
                          text={languageTexts.confirm}
                          bordered={false}
                          onClick={() => {
                            handleModals(MODAL_TYPE.COMMENT, "end", null)
                          }}
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </>
          ) : null}
          <div className="absolute left-0 bottom-0 flex flex-row items-start">
            {/* Existing gradient label - only shows if suggestions exist */}
            {props.application.user?.suggestions?.length ? (
              <div
                className={classNames([
                  props.isSelectable ? "cursor-pointer" : "cursor-default",
                ])}
                onClick={props.onClick && props.onClick}
              >
                <Label
                  className="px-[6px] pt-[0px] pb-[1px] !rounded-none bg-gradient-to-r from-[#FA7035] to-[#FF0099]"
                  // labelColor="#FF0099"
                  textClassName="font-bold text-[11px]"
                  textColor="white"
                  text={languageTexts.suggested_by_admin}
                />
              </div>
            ) : null}
            {/* New black label - shows independently */}
            {props.application.user.isNew ? (               
                <Label
                className="px-[6px] pt-[0px] pb-[1px] bg-black !rounded-none"
                textClassName="font-bold text-[11px]"
                textColor="white"
                text={languageTexts.new_influencer_within_30_days}
              />                           
            ) : null}
          </div>
        </div>
        <div className="flex flex-col gap-1">
          <div
            className={classNames([
              "flex flex-col gap-1 mt-[18px] px-[10px]",
              props.isSelectable ? "cursor-pointer" : "cursor-default",
            ])}
            onClick={props.onClick && props.onClick}
          >
            <div className="flex flex-row items-center justify-start mb-[-6px]">
              {/* {props.application.user.isNew ? (
                <img className="w-[16px] h-[16px] mr-[4px]" src={`/assets/icons/ic-new.svg`} />
              ) : null} */}

              <span className="font-bold text-[20px] tracking-tighter">{props.application.user.username}</span>
            </div>

            {!props.brand.isCategoryBeauty ? (
              <>
                <div className="flex flex-row items-center justify-center">
                  <img className="mr-1 w-3 h-3" src={`/assets/icons/ic-star-gold.svg`} />
                  <span className="text-[11px] tracking-tighter mr-2">
                    {props.application.user.userModel.averageRatingsByAdmin
                      ? props.application.user.userModel.averageRatingsByAdmin.toFixed(1)
                      : "0.0"}
                  </span>
                </div>

                <div className="flex flex-row justify-center">
                  <span className="text-[10px] tracking-tighter">
                    {languageTexts._modelSize0(props.application.user.userModel.age)}
                  </span>
                </div>
              </>
            ) : null}

            {props.application?.user?.userModel?.instaUserId && <span
              className="flex flex-col text-[10px] text-[#999999] tracking-tighter"
              onClick={() => {
                window.open(`https://www.instagram.com/${props.application.user.userModel.instaUserId}`, '_blank');
              }}
            >
              @{props.application.user.userModel.instaUserId}
            </span>}

            {props.brand.isCategoryFashion ? (
              <>
                <div className="flex flex-row justify-center">
                  <span className="text-[10px] tracking-tighter">
                    {languageTexts._modelSize1(
                      props.application.user.userModel.height,
                      props.application.user.userModel.topSize,
                      props.application.user.userModel.bottomSize
                    )}
                  </span>
                </div>

                {props.isShoes && props.application.user.userModel.shoesSize ? (
                  <div className="flex flex-row justify-center">
                    <span className="text-[11px] tracking-tighter opacity-50">
                      {languageTexts._modelSize2(props.application.user.userModel.shoesSize)}
                    </span>
                  </div>
                ) : null}

                {props.isUnderwear &&
                props.application.user.userModel.braSize &&
                props.application.user.userModel.pantieSize ? (
                  <div className="flex flex-row justify-center">
                    <span className="text-[11px] tracking-tighter opacity-50">
                      {languageTexts._modelSize3(
                        props.application.user.userModel.braSize,
                        props.application.user.userModel.pantieSize
                      )}
                    </span>
                  </div>
                ) : null}
              </>
            ) : null}

            {(!props?.isInfluencersPage && props.brand.isCategoryBeauty && props.application?.commissionAmount != null) ? (
              <div className="flex flex-col">
                <div className="flex flex-row justify-start">
                  <span className="text-[15px] font-bold tracking-tighter">
                    {props?.application?.isCommissionAmountIncreased >= 1 ? 
                    languageTexts.increased_commission_amount_applied(props.application.commissionAmount / 10000, 
                      (isKyolook() || isGlovvJp()) ? languageTexts.currencyUnitJPY : languageTexts.currencyUnitKRW
                    ) 
                    : languageTexts.original_commission_amount_applied(props.application.commissionAmount / 10000, 
                      (isKyolook() || isGlovvJp()) ? languageTexts.currencyUnitJPY : languageTexts.currencyUnitKRW
                    )}
                  </span>
                </div>
              </div>
            ) : null}

            <div className="flex flex-col pt-3 pb-[2px]">
              {/* <table className="table-fixed border-collapse border border-slate-[#F4F4F4]"> */}
              <table className="table-fixed border-collapse border-slate-[#F4F4F4]">
                <tbody>
                  <tr className="!border-b border-slate-[#F4F4F4]">
                    {!props.brand?.isCategoryBeauty ? (
                      <td className="border border-slate-[#F4F4F4] w-1/2 py-2">
                        <div className="flex flex-col items-center">
                          <span className="text-[11px] tracking-tighter">{languageTexts.like}</span>
                          <span>
                            <b>
                              {props.application.likesAverage ? props.application.likesAverage.toLocaleString() : "0"}
                            </b>
                          </span>
                        </div>
                      </td>
                    ) : null}
                    <td className="w-1/2 py-2">
                      <div className="flex flex-row items-center justify-between">
                        <span className="text-[11px] tracking-tighter">{languageTexts.followers}</span>
                        <span className="text-[11px]">
                          <b>{props.application.followers ? props.application.followers.toLocaleString() : "0"}</b>
                        </span>
                      </div>
                    </td>
                  </tr>
                  {props.brand.isCategoryFashion ? (
                    <tr>
                      <td className="border border-slate-[#F4F4F4] w-1/2 py-2">
                        <div className="flex flex-col items-center">
                          <span className="text-[11px] tracking-tighter">{languageTexts.ambassador_approved}</span>
                          <span className="font-bold">
                            {props.application.user.brandsInAmbassadorRoleCount?.toLocaleString() || "0"}
                          </span>
                        </div>
                      </td>
                      <td className="border border-slate-[#F4F4F4] w-1/2 py-2">
                        <div className="flex flex-col items-center">
                          <span className="text-[11px] tracking-tighter">{languageTexts.brand_reselected}</span>
                          <span className="font-bold">
                            {props.application.user.brandsSelectedFrequentlyCount?.toLocaleString() || "0"}
                          </span>
                        </div>
                      </td>
                    </tr>
                  ) : null}
                  {/* <tr>
                    <td
                      className="border border-slate-[#F4F4F4] w-1/2 py-2"
                      colSpan={props.type == TYPES.CAMPAIGN ? undefined : 2}
                    >
                      <div className="flex flex-col items-center">
                        <span className="text-[11px] text-[#FF0099] tracking-tighter">{languageTexts.dibs}</span>
                        <span className="text-[#FF0099]">
                          <b>
                            {props.application.likesCntByBrands
                              ? props.application.likesCntByBrands.toLocaleString()
                              : "0"}
                          </b>
                        </span>
                      </div>
                    </td>
                    <td className="border border-slate-[#F4F4F4] w-1/2 py-2">
                      {props.type == TYPES.CAMPAIGN ? (
                        <div className="flex flex-col items-center">
                          <span className="text-[11px] tracking-tighter">{languageTexts.cum_sel}</span>
                          <span>
                            <b>
                              {props.application.campaignAcceptedCnt
                                ? props.application.campaignAcceptedCnt.toLocaleString()
                                : "0"}
                            </b>
                          </span>
                        </div>
                      ) : null}
                    </td>
                  </tr> */}
                  <tr>
                    {props.type == TYPES.CAMPAIGN ? (
                      <td className="" colSpan={2}>                    
                        <div className="flex flex-col items-center">                         
                          {/* ADDED: Wrapper div for top section */}
                          <div className="w-full py-2 !border-b border-slate-[#F4F4F4]"
                          >
                            {/* UNCHANGED: Existing selection history hover */}
                            <span
                              className="flex flex-row justify-between items-center text-[11px] tracking-tighter text-black cursor-pointer"
                              onMouseOver={(event) =>
                                {             
                                  !props.preferences.isMobile && handleModals(MODAL_TYPE.HISTORY, "start", event)
                                }
                              }
                              onMouseLeave={(event) =>
                                !props.preferences.isMobile && handleModals(MODAL_TYPE.HISTORY, "end", event)
                              }
                              onTouchStart={() => {
                                if (props.preferences.isMobile) {
                                  const command = isHistoryVisible ? "end" : "start"
                                  handleModals(MODAL_TYPE.HISTORY, command, event)
                                }
                              }}                              
                            >
                              <span>{languageTexts.sel_history_entire_period}</span>
                              <b>{props.application.campaignAcceptedCntRelated ?? "0"}</b>
                            </span>
                          </div>
                          {/* ADDED: End wrapper div */}

                          {/* ADDED: Divider line */}
                          {/* <div className="w-full border-t border-slate-[#E8E8E8]" /> */}

                          {/* ========== BOTTOM SECTION: 다른 캠페인에도 지원중 ========== */}
                          {/* ADDED: Bottom section - Other campaigns currently applying to */}
                          <div className="w-full py-2"                              
                          >
                            <span
                              className="flex flex-row justify-between items-center text-[11px] tracking-tighter text-black cursor-pointer"
                              onMouseOver={(event) =>
                                !props.preferences.isMobile && handleModals(MODAL_TYPE.OTHER_APPLYING, "start", event)
                              }
                              onMouseLeave={(event) =>
                                !props.preferences.isMobile && handleModals(MODAL_TYPE.OTHER_APPLYING, "end", event)
                              }
                              onTouchStart={() => {
                                if (props.preferences.isMobile) {
                                  const command = isOtherApplyingVisible ? "end" : "start"
                                  handleModals(MODAL_TYPE.OTHER_APPLYING, command, event)
                                }
                              }}                              
                            >
                              {/* MODIFIED: Use real count from backend */}
                              {languageTexts.products_applied_in_brand}
                              <b>{props.application.productsAppliedInBrandCnt ? props.application.productsAppliedInBrandCnt : "0"}</b>
                            </span>
                          </div>
                          {/* ADDED: End bottom section */}                         
                        </div>
                      </td>
                    ) : null}
                  </tr>                                 
                </tbody>
              </table>
              {props.type == TYPES.CAMPAIGN && (
                <>
                  {/* UNCHANGED: Existing history modal */}    
                  <div className={`modal ${isHistoryVisible ? "" : "hidden"}`}> 
                    <div
                      className={`w-fit h-fit rounded-[1.125rem] flex flex-col fixed inset-0 justify-center items-center z-[10] translate-x-[-50%] translate-y-[-50%] left-[50%] top-[50%] animate__animated animate__fadeIn ${
                        props.preferences.isMobile ? "w-[90vw]" : ""
                      }`}
                      onMouseOver={(event) =>
                        {             
                          !props.preferences.isMobile && handleModals(MODAL_TYPE.HISTORY, "start", event)
                        }
                      }
                      onMouseLeave={(event) =>
                        !props.preferences.isMobile && handleModals(MODAL_TYPE.HISTORY, "end", event)
                      }
                      onTouchStart={() => {
                        if (props.preferences.isMobile) {
                          const command = isHistoryVisible ? "end" : "start"
                          handleModals(MODAL_TYPE.HISTORY, command, event)
                        }
                      }}
                    >
                      <div
                        className="flex flex-col bg-white rounded-[1.125rem] gap-5 p-5 md:p-10"
                        style={{
                          boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.25)",
                        }}
                      >
                        <div className="flex flex-col gap-3 md:gap-5">
                          <div className="flex flex-row">
                            
                            <span className="flex flex-col text-start font-bold text-lg md:text-2xl tracking-tighter">
                              {languageTexts._modelSelHistoryEntirePeriod(props.application.user.username, props.application.campaignAcceptedCntRelated)}
                            </span>
                          </div>
                          <span className="flex flex-col text-start font-bold text-base tracking-tighter text-[#999999]">
                            {languageTexts._listLimit(5)}
                          </span>
                        </div>

                        <div className="flex flex-col">
                          {props.application.latestCampaignsAccepted &&
                          props.application.latestCampaignsAccepted.length
                            ? props.application.latestCampaignsAccepted.map((applicant, i) => {
                                return (
                                  <div key={applicant?.id} className="flex flex-row gap-6">
                                {/* Using unique id for key */}
                                    <div className="w-[5.625rem] h-[5.625rem]">
                                      <img
                                        className="w-full h-full object-contain"
                                        src={applicant.product.thumbnailSmUrl}
                                      />
                                    </div>
                                    <div className="flex flex-col my-auto gap-[0.375rem]">
                                      <span className="w-full text-base tracking-tighter text-black">
                                        {applicant.product.name}
                                      </span>
                                      <span className="w-full text-sm tracking-tighter text-[#999999]">
                                        {dayjs(applicant.applyAcceptedAt).format("YYYY/MM/DD")}
                                      </span>
                                    </div>
                                  </div>
                                )
                              })
                            : null}
                        </div>
                        <div>
                          {props.preferences.isMobile ? <Button
                            className="w-full py-[8px] flex justify-center font-bold"
                            buttonColor={"#000"}
                            textColor={"WHITE"}
                            text={languageTexts.confirm}
                            bordered={false}
                            onClick={(event) => {
                              handleModals(MODAL_TYPE.HISTORY, "end", event)
                            }}
                          /> : null}                          
                        </div>
                      </div>
                    </div>
                  </div> 
                  {/* UNCHANGED: End history modal */}
                  {/* ========== OTHER APPLYING MODAL ========== */}              
                  {/* ADDED: New other applying modal */}
                  <div className={`${isOtherApplyingVisible ? "" : "hidden"}`}>
                    <div
                      className={`w-fit h-fit rounded-[1.125rem] flex flex-col fixed inset-0 justify-center items-center z-[10] translate-x-[-50%] translate-y-[-50%] left-[50%] top-[50%] animate__animated animate__fadeIn ${
                        props.preferences.isMobile ? "w-[90vw]" : ""
                      }`}
                      onMouseOver={(event) =>
                        !props.preferences.isMobile && handleModals(MODAL_TYPE.OTHER_APPLYING, "start", event)
                      }
                      onMouseLeave={(event) =>
                        !props.preferences.isMobile && handleModals(MODAL_TYPE.OTHER_APPLYING, "end", event)
                      }
                      onTouchStart={() => {
                        if (props.preferences.isMobile) {
                          const command = isOtherApplyingVisible ? "end" : "start"
                          handleModals(MODAL_TYPE.OTHER_APPLYING, command, event)
                        }
                      }}
                    >
                      <div
                        className="flex flex-col bg-white rounded-[1.125rem] gap-5 p-5 md:p-10"
                        style={{
                          boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.25)",
                        }}
                      >
                        {/* Modal Header */}
                        <div className="flex flex-col gap-3 md:gap-5">
                          <div className="flex flex-row">
                            
                            <span className="flex flex-col text-start font-bold text-lg md:text-2xl tracking-tighter">
                              {languageTexts._modelProductsAppliedInBrand(props.application.user.username, props.application.productsAppliedInBrandCnt)}
                            </span>
                          </div>
                          <span className="flex flex-col text-start font-bold text-base tracking-tighter text-[#999999]">
                            {languageTexts._listLimit(5)}
                          </span>
                        </div>

                        {/* MODIFIED: Replace placeholder with actual product list */}
                        <div className="flex flex-col gap-4">
                          {props.application.productsAppliedInBrand && 
                          props.application.productsAppliedInBrand.length > 0 ? (
                            props.application.productsAppliedInBrand.map((applicant, i) => (
                              <div key={applicant?.id} className="flex flex-row gap-6">
                                {/* Using unique id for key */}
                                {/* Product Image */}
                                <div className="w-[5.625rem] h-[5.625rem]">
                                  <img
                                    className="w-full h-full object-contain"
                                    src={applicant.product.thumbnailSmUrl}
                                  />
                                </div>
                                {/* Product Info */}
                                <div className="flex flex-col my-auto gap-[0.375rem]">
                                  <span className="w-full text-base tracking-tighter text-black">
                                    {applicant.product.name}
                                  </span>
                                  <span className="w-full text-sm tracking-tighter text-[#999999]">
                                    {dayjs(applicant.createdAt).format("YYYY/MM/DD")}
                                  </span>
                                </div>
                              </div>
                            ))
                          ) : (
                            <span className="text-base tracking-tighter text-[#999999]">
                              
                            </span>
                          )}
                        </div>

                        {/* Close Button */}
                        <div>
                          {props.preferences.isMobile ? <Button
                            className="w-full py-[8px] flex justify-center font-bold"
                            buttonColor={"#000"}
                            textColor={"WHITE"}
                            text={languageTexts.confirm}
                            bordered={false}
                            onClick={(event) => {
                              handleModals(MODAL_TYPE.OTHER_APPLYING, "end", event)
                            }}
                          /> : null}                          
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* ADDED: End other applying modal */}
                </>
              )}
            </div>

            {/* <div className="flex flex-col gap-[5px]">
              <div className="flex flex-row items-center justify-center gap-1">
                <span className="text-[11px]">{languageTexts.ignore_guideline}</span>
                <span className="text-[11px] font-bold">
                  {props.application.user.userModel.feedbacksCampaignGuideCnt
                    ? props.application.user.userModel.feedbacksCampaignGuideCnt.toLocaleString()
                    : 0}
                </span>
              </div>

              <div className="flex flex-row items-center justify-center gap-1">
                <span className="text-[11px]">{languageTexts.ignore_posting_deadline}</span>
                <span className="text-[11px] font-bold">
                  {props.application.user.userModel.feedbacksCampaignOverdueCnt
                    ? props.application.user.userModel.feedbacksCampaignOverdueCnt.toLocaleString()
                    : 0}
                </span>
              </div>
            </div> */}
          </div>
          <div className="flex flex-col mt-[10px] gap-[5px]">
            {props.brand?.isCategoryBeauty &&
            (props.application?.appealReelsUrl != null || props.application?.user?.userModel?.appealReelsUrl != null)
              ? renderAppealReelsButton({
                  isAppealReelsOpened: isAppealReelsOpened,
                  onClick: async () => {
                    let couldContinue = await isConfirmedModalShouldCheckReels()
                    if (couldContinue !== true) {
                      return
                    }
                    let transformedUrl = props.application?.appealReelsUrl ?? props.application?.user?.userModel?.appealReelsUrl 
                    const instaUserId = props.application?.instaUserId ?? props.application?.user?.userModel?.instaUserId

                    if (props?.isInfluencersPage && instaUserId) {
                      transformedUrl = `https://instagram.com/${instaUserId}/reels`
                    }
                
                    handleOpenAppealReels({
                      url: transformedUrl,
                      type: props.type,
                      applicationId: props.application.id,
                    })
                  },
                })
              : renderInstagramButton({
                  isInstagramOpened: isInstagramOpened,
                  onClick: async () => {
                    let couldContinue = await isConfirmedModalShouldCheckReels()
                    if (couldContinue !== true) {
                      return
                    }
                    handleOpenInstagramUrl({
                      url: `https://instagram.com/${props.application.user.userModel.instaUserId}${
                        props.brand?.isCategoryBeauty ? "/reels" : ""
                      }`,
                      type: props.type,
                      applicationId: props.application.id,
                    })
                  },
                })}
            <div className="flex flex-col gap-[5px]">
              {/* 이 캠페인에서만 찜하기/찜했음 - NEW BUTTON (ABOVE) */}
              {props?.isInfluencersPage ? 
                null : 
                <Button
                  className={`flex flex-row py-2 text-center justify-center !rounded-none ${props.application.productUserLikes && props.application.productUserLikes.length ? "" : "!border-transparent"}`}
                  buttonColor={props.application.productUserLikes && props.application.productUserLikes.length ? "WHITE" : "BLACK"}
                  textColor={props.application.productUserLikes && props.application.productUserLikes.length ? "BLACK" : "WHITE"}
                  textClassName="text-[11px] tracking-tighter font-bold"
                  text={
                    props.application.productUserLikes && props.application.productUserLikes.length
                      ? languageTexts?.product_like_influencer_1
                      : languageTexts?.product_like_influencer_2
                  }
                  onClick={() => {
                    props.onProductUserLike ? props.onProductUserLike() : null
                  }}
                />
              }
              
              {/* 저장해두기/저장했음 - OLD BUTTON (BELOW) */}
              <Button
                className={`flex flex-row py-2 text-center justify-center !rounded-none ${props.application.likes && props.application.likes.length ? "" : "!border-transparent"}`}
                buttonColor={props.application.likes && props.application.likes.length ? "WHITE" : "BLACK"}
                textColor={props.application.likes && props.application.likes.length ? "BLACK" : "WHITE"}
                textClassName="text-[11px] tracking-tighter font-bold"
                text={
                  props.application.likes && props.application.likes.length 
                    ? languageTexts?.brand_like_influencer_1  
                    : languageTexts?.brand_like_influencer_2  
                }
                // icon={
                //   props.application.likes && props.application.likes.length
                //     ? {
                //         position: "centerRight",
                //         icon: (
                //           <div className="self-center text-white ml-0.5">
                //             <ICON_CHECK
                //               size={16}
                //               color={props.application.likes && props.application.likes.length ? "BLACK" : "WHITE"}
                //               style={{ strokeWidth: "2.5px" }}
                //             />
                //           </div>
                //         ),
                //       }
                //     : null
                // }
                onClick={handleInfluencerLikeBtnClick}
              />
            </div>
          </div>
        </div>
        <div className="-mx-[10px] border-t border-[#E8E8E8] my-[10px]" />
        <Button
                className={`flex flex-row py-2 text-center justify-center !rounded-none`}
                buttonColor={"WHITE"}
                textColor={ "BLACK"}
                textClassName="text-[11px] tracking-tighter font-bold"
                text={influncerMessageButtonText}
                onClick={()=>{handleInfluencerMessageBtnClick(props.application)}}
              />
      </div>
      {props.brand.isCategoryBeauty && (
        props.isInfluencersPage || props.campaignData?.status === CampaignStatus?.COMPLETED
      ) && (
        <div
          className="mt-[8px] text-[11px] text-[#999] text-center underline cursor-pointer"
          onClick={handleBrandRequestRecruitingCampaignApplicationClick}  
        >         
          {languageTexts?.brand_request_recruiting_campaign_application_btn_text}
        </div>
      )}
      {props.application.rental
        ? renderPostingDtInfo(
            props.application.rental.postingDt,
            props.campaignData?.latestPostingEndsAt
              ? props.campaignData.latestPostingEndsAt
              : props.campaignData.postingEndsAt,
            props.application.rental.inspectionSubmitDueDt,
            props.application.rental.inspectionSubmittedAt,
            props.application.rental.memo,
            props.application.rental.inspectionMemo,
            props.application.rental.rentalPostingDues,
          )
        : null}

      {/* {props.type == TYPES.AMBASSADOR ? (
        <div className="flex flex-row mt-[10px]">
          {props.application.approvedAt ? null : (
            <div className="flex flex-1">
              <Button
                className="flex justify-center items-center w-full h-[48px]"
                buttonColor={"#000000"}
                textClassName={"text-[14px] font-bold"}
                text={languageTexts.approve}
                textColor={"WHITE"}
                onClick={() => {
                  props.onAmbassadorApprove
                    ? props.onAmbassadorApprove()
                    : null;
                }}
              />
            </div>
          )}
          <div className="flex flex-1">
            <Button
              className="flex justify-center items-center w-full h-[48px]"
              textClassName={"text-[14px] font-bold"}
              text={languageTexts.decline}
              onClick={() => {
                props.onAmbassadorDecline ? props.onAmbassadorDecline() : null;
              }}
            />
          </div>
        </div>
      ) : null} */}
      {/* {isInstagramDrawerActive ? (
        <InstagramDrawer
          isActive={isInstagramDrawerActive}
          setIsActive={setIsInstagramDrawerActive}
          _user={props.application.user}
          _application={props.application}
          nextUser={props.nextUser}
          previousUser={props.previousUser}
          selected={props.selected}
          onSelect={props.onClick}
          onLike={props.onLike}
        />
      ) : null} */}
      
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchProps)(ModelCard)